/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Not_FoundInputs */



/**
* | output |
* | --- |
* | "League not found" |
*
* @param {League_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_not_found = /** @type {((inputs?: League_Not_FoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Not_FoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ligue introuvable")
	if (locale === "es") return /** @type {LocalizedString} */ ("Liga no encontrada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Liga não encontrada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Campionato non trovato")
	return /** @type {LocalizedString} */ ("League not found")
});